import { toNoemirError } from '../contracts/errors';
import type { BootstrapState, CoreClient } from '../contracts/foundation';

export const bootstrapCore = async (client: CoreClient): Promise<BootstrapState> => {
  try {
    const foundation = await client.initialize();
    return { status: 'ready', foundation };
  } catch (error: unknown) {
    return { status: 'failed', error: toNoemirError(error).state };
  }
};
